/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Complete_TitleInputs */

const en_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're all set!`)
};

const de_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles erledigt!`)
};

const fr_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu es prêt !`)
};

const es_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Todo listo!`)
};

const it_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai finito!`)
};

const nl_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent klaar!`)
};

const pl_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowe!`)
};

const fi_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olet valmis!`)
};

const da_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du er klar!`)
};

const sv_onboarding_complete_title = /** @type {(inputs: Onboarding_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du är klar!`)
};

/**
* | output |
* | --- |
* | "You're all set!" |
*
* @param {Onboarding_Complete_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_complete_title = /** @type {((inputs?: Onboarding_Complete_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Complete_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_complete_title(inputs)
	if (locale === "fr") return fr_onboarding_complete_title(inputs)
	if (locale === "es") return es_onboarding_complete_title(inputs)
	if (locale === "it") return it_onboarding_complete_title(inputs)
	if (locale === "nl") return nl_onboarding_complete_title(inputs)
	if (locale === "pl") return pl_onboarding_complete_title(inputs)
	if (locale === "fi") return fi_onboarding_complete_title(inputs)
	if (locale === "da") return da_onboarding_complete_title(inputs)
	if (locale === "sv") return sv_onboarding_complete_title(inputs)
	return en_onboarding_complete_title(inputs)
});